import { useNavigate } from '@tanstack/react-router'

import { useAuthenticatedFirebaseUser } from '@/auth/useFirebaseUser'
import { SupportButton } from '@/components/organisms/SupportButton'
import { SupportPanelSheet } from '@/components/organisms/SupportPanel'
import { useSupportPanelStore } from '@/state/support/supportPanelStore'
import { useAgentSupportRequests, useSupportAgentUnreadCount } from '@/state/support/useAgentSupportRequests'
import { useRequesterSupportRequests } from '@/state/support/useRequesterSupportRequests'
import { useSupportReads } from '@/state/support/useSupportReads'
import { useSupportRequesterSound } from '@/state/support/useSupportRequesterSound'

import { RequesterSupportPanel } from './RequesterSupportPanel'

const RequesterSupportEntry = () => {
  const { open, view, openPanel, closePanel } = useSupportPanelStore()
  const { requests, loadState, retry } = useRequesterSupportRequests()
  const { isUnreadByRequester } = useSupportReads()
  useSupportRequesterSound(requests, { isLoaded: loadState === 'ready', panelOpen: open })

  return (
    <>
      <SupportButton
        count={requests.filter((request) => isUnreadByRequester(request)).length}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={openPanel}
      />
      <SupportPanelSheet
        open={open}
        wide={view.kind !== 'requests'}
        onOpenChange={(isOpen) => (isOpen ? openPanel() : closePanel())}>
        <RequesterSupportPanel requests={requests} loadState={loadState} onRetry={retry} />
      </SupportPanelSheet>
    </>
  )
}

const AgentSupportEntry = () => {
  const navigate = useNavigate()
  const { requests } = useAgentSupportRequests()
  const count = useSupportAgentUnreadCount(requests)
  return <SupportButton count={count} onClick={() => navigate({ to: '/soutien' })} />
}

export const SupportEntry = () => {
  const { supportRequester, supportRole } = useAuthenticatedFirebaseUser()
  if (supportRole !== null) {
    return <AgentSupportEntry />
  }
  if (!supportRequester) {
    return null
  }
  return <RequesterSupportEntry />
}
